import React from 'react'

import { LinkTrackingPage } from '@/modules/tracking/links/components/link-tracking-page.tsx'

export const FreeTrialLinksPage = () => {
  return <LinkTrackingPage type="Trial" />
}
